import { createFileRoute } from '@tanstack/react-router'

import { ReportPage } from '@/components/reports/report-page'
import { YieldLossTab } from '@/components/reports/yield-loss-tab'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/yield-loss',
)({
    component: YieldLossReportPage,
})

function YieldLossReportPage() {
    return (
        <ReportPage title={m.report_page_title_yield_loss()}>
            <YieldLossTab />
        </ReportPage>
    )
}
